<template>
  <div class="invite" :style="'background-image:url('+img.pagebg+');height:'+winHeight+'px;background-size: 100% '+winHeight+'px;'">
    <div class="div_mask">
      <div class="text-c">
       <div class="f-16" style="padding-top: 90px;align-items: center;color: #4A4A4A;">「凌志范儿」诚挚地邀请您参加 </div>
       <div class="f-16" style="align-items: center;display: inline-flex;color: #4A4A4A;"><img class="sficon" :src="img.member_car">  车主认证</div>
     </div>
     <div class="f-14" style="color: #666666;padding: 15px 36px;">展示效果</div>
     <div class="info">
      <span class="headbox">
        <img class="head" :src="otherinfo.avatar&&otherinfo.avatar.substring(0,5)=='https' ? otherinfo.avatar : img.avatar">
        <img class="headsficon" v-if="otherinfo.auth.is_audit==1" :src="img.border">
      </span>
      <div class="f-14 f-w" style="color: #605C6B;margin-bottom: 10px;margin-top: 10px;">{{otherinfo.username}}</div>
      <div class="f-12" style="color: #979797;margin-top: 5px;display: flex;" ><img class="member_car" :src="img.member_car">雷克萨斯车主</div>
    </div>
    <div class="carbtn" @click="goCarapprove" v-if="!inputfocus">车主认证</div>
  </div>
</div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon} from 'vant';
  export default {
    data () {
      return {
        winHeight:568,
        otherinfo:'',
        source:1,
        docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
        showHeight: document.documentElement.clientHeight,   //实时屏幕高度
        value:'',
        img:{
          avatar:require('../../../assets/img/lexus/default.png'),
          sficon: require('../../../assets/img/lexus/approve/sficon.png'),
          lexus: require('../../../assets/img/lexus/approve/qrcode.png'),
          border: require('../../../assets/img/lexus/border.gif'),
          pagebg:require('../../../assets/img/lexus/approve/approveno_bg.png'),
          member_car: require('../../../assets/img/member_car.png'),
          nextimg: require('../../../assets/img/lexus/approve/nextimg.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    mounted() {
      window.onresize = () => {
       return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        this.showHeight = window.fullHeight;
      })()
    };
  },
  watch: {
    showHeight (val) {
      let that = this;
      that.show2 = true;
      if (that.docmHeight > val){
        that.inputfocus=true
      } else{
        setTimeout(function(){
          that.inputfocus=false
        },100)
      }
    }
  }, 
  created () {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.winHeight=h
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: false})
    this.$appService.isTabbar({state: true})
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    if(this.$route.query.token){
      this.source = this.$route.query.source
      this.token = this.$route.query.token
      this.user_id = this.$route.query.userid
      this.$store.dispatch('param/setToken', this.$route.query.token)
      this.getUserOther(this.$route.query.userid)
    }else{
      this.source = this.$route.params.source
      this.token = this.$route.params.token
      this.$store.dispatch('param/setToken', this.$route.params.token)
      this.user_id = this.$route.params.user_id
      this.getUserOther(this.$route.params.user_id)
    }
    var params={
      event_code: '邀请认证',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/Approve/LexusInvite.vue',
      user_id: this.user_id ? this.user_id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){

      }
    })
    var apppar={
      title:this.$route.meta.title
    }
    this.$appService.changeTitle(apppar)
  },
  methods: {
    getUserOther(id){
      var params={
        user_id:parseInt([id]),
        source:this.source
      }
      member.userOther(params).then(res => {
        if(res.data.state==1){
          this.otherinfo=res.data.data
        }
      })
    },
    
    goCarapprove(){
     wx.miniProgram.redirectTo({url:'/pages/approve/approve'})
   },




 },
 components: {
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [Field.name]:Field,
  [Button.name]:Button,
  [Icon.name]:Icon
}
}
</script>
<style lang="scss">
  .invite{
    width: 100%;
  // background-color:#f1f1f1;
  .div_mask{
    width: 100%;
    height: 100%;
  }
  .sficon{
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }
  .van-field__label{
    color: #666666;
  }
  .van-field__button{
    text-align: left;
    position:absolute;
  }
  .van-field__control{
    color: #333333;
  }
  .van-cell{
    color: #A3A3A3;
    background:transparent;
  }
  .info{
    min-height: 120px;
    z-index: 99;
    margin:0 15px;
    background-color: #fff;
    border-radius: 1.5px;
    padding:20px;
    box-shadow: 0.053333rem 0.053333rem 0.133333rem rgba(0, 0, 0, 0.05);
    .headbox{
      position: relative;
      width: 60px;
      height: 60px;
    }
    .head{
      width: 60px;
      height: 60px;
      border-radius: 1.5px;
    }
    .headsficon{
      width: 60px;
      height: 60px;
      position: absolute;
        // bottom: 7px;
        right: 0px;
      }
      .buttonin{
        float: right;
        margin-top: 15px;
      }
      .van-button--small{
        height: 28px;
        padding: 0 8px;
        line-height: 20px;
        border-radius: 1px;
        vertical-align: middle;
      }
      .van-button__icon{
        font-size: 10px;
      }
      .van-button__text{
        font-size: 11px;
      }
      .member_car{
        width: 15px;
        height: 15px;
      }
    }
    .carbtn{
      font-size: 14px;
      text-align: center;
      background: #605C6B;
      color: #fff;
      padding:15px 30px;
      position: fixed;
      top: 73%;
      left: 34%;
    }
    .nextStep{
      color: #999999;
      font-size: 14px;
      text-align: center;
      position: fixed;
      top: 83%;
      left: 44%;
      .nextimg{
        width: 13px;
        height:12px;
      }
    }
  }
</style>
